import React from 'react';
import { Container, Typography, Paper, Box } from '@mui/material';
import { motion } from 'framer-motion';
import '../styles/LegalPages.scss';

const Terms = () => {
    return (
        <div className="legal-page terms-page">
            <motion.div
                className="page-header"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.8 }}
            >
                <div className="header-background" />
                <Container>
                    <motion.div
                        initial={{ y: -30, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        transition={{ delay: 0.2, duration: 0.8 }}
                        className="header-content"
                    >
                        <Typography variant="h1">Általános Szerződési Feltételek</Typography>
                        <Typography variant="subtitle1">
                            Érvényes: 2024. január 1-től
                        </Typography>
                    </motion.div>
                </Container>
            </motion.div>

            <Container>
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.4, duration: 0.6 }}
                >
                    <Paper elevation={3} sx={{ p: 4, mt: -8, mb: 6, borderRadius: 2 }}>
                        <Box mb={4}>
                            <Typography variant="h5" gutterBottom color="primary">
                                1. Általános rendelkezések
                            </Typography>
                            <Typography paragraph>
                                Jelen Általános Szerződési Feltételek (továbbiakban: ÁSZF) tartalmazza a Toronyszerver KFT.
                                (székhely: 2230 Gyömrő, Állomás utca 15., cégjegyzékszám: [Cégjegyzékszám],
                                adószám: [Adószám]) által nyújtott építőipari szolgáltatások igénybevételének feltételeit.
                            </Typography>
                        </Box>

                        <Box mb={4}>
                            <Typography variant="h5" gutterBottom color="primary">
                                2. Szolgáltatások
                            </Typography>
                            <Typography paragraph>
                                A vállalkozó az alábbi főbb szolgáltatásokat nyújtja:
                            </Typography>
                            <ul>
                                <li>Ipari létesítmények kivitelezése</li>
                                <li>Kereskedelmi ingatlanok kivitelezése</li>
                                <li>Toronyépítés</li>
                                <li>Felújítási munkálatok</li>
                                <li>Infrastrukturális fejlesztések</li>
                            </ul>
                        </Box>

                        <Box mb={4}>
                            <Typography variant="h5" gutterBottom color="primary">
                                3. Szerződéskötés
                            </Typography>
                            <Typography paragraph>
                                3.1. A szerződés a megrendelő és a vállalkozó között írásban jön létre.
                            </Typography>
                            <Typography paragraph>
                                3.2. A szerződés tartalmazza a kivitelezés részletes műszaki tartalmát,
                                az árakat, határidőket és egyéb feltételeket.
                            </Typography>
                            <Typography paragraph>
                                3.3. A szerződés csak mindkét fél által aláírt módosítással változtatható meg.
                            </Typography>
                        </Box>

                        <Box mb={4}>
                            <Typography variant="h5" gutterBottom color="primary">
                                4. Árak és fizetési feltételek
                            </Typography>
                            <Typography paragraph>
                                4.1. Az árak egyedi megállapodás alapján kerülnek meghatározásra.
                            </Typography>
                            <Typography paragraph>
                                4.2. A fizetés ütemezése a szerződésben kerül rögzítésre.
                            </Typography>
                            <Typography paragraph>
                                4.3. Késedelmes fizetés esetén a vállalkozó jogosult késedelmi kamatot felszámítani.
                            </Typography>
                        </Box>

                        <Box mb={4}>
                            <Typography variant="h5" gutterBottom color="primary">
                                5. Teljesítési határidők
                            </Typography>
                            <Typography paragraph>
                                5.1. A teljesítési határidők a szerződésben kerülnek meghatározásra.
                            </Typography>
                            <Typography paragraph>
                                5.2. Vis maior esetén a határidők módosulhatnak.
                            </Typography>
                        </Box>

                        <Box mb={4}>
                            <Typography variant="h5" gutterBottom color="primary">
                                6. Minőség és garancia
                            </Typography>
                            <Typography paragraph>
                                6.1. A vállalkozó garantálja a munkák szakszerű elvégzését.
                            </Typography>
                            <Typography paragraph>
                                6.2. A garanciális időszak az átadás-átvételtől számítva:
                            </Typography>
                            <ul>
                                <li>Szerkezeti munkák: 10 év</li>
                                <li>Szakipari munkák: 5 év</li>
                                <li>Beépített berendezések: gyártói garancia szerint</li>
                            </ul>
                        </Box>

                        <Box mb={4}>
                            <Typography variant="h5" gutterBottom color="primary">
                                7. Felelősség
                            </Typography>
                            <Typography paragraph>
                                7.1. A vállalkozó felelősségbiztosítással rendelkezik.
                            </Typography>
                            <Typography paragraph>
                                7.2. A vállalkozó felelős az általa okozott károkért.
                            </Typography>
                        </Box>

                        <Box mb={4}>
                            <Typography variant="h5" gutterBottom color="primary">
                                8. A szerződés megszűnése
                            </Typography>
                            <Typography paragraph>
                                8.1. A szerződés megszűnik a teljesítéssel.
                            </Typography>
                            <Typography paragraph>
                                8.2. Rendkívüli felmondás esetei a szerződésben kerülnek meghatározásra.
                            </Typography>
                        </Box>

                        <Box mb={4}>
                            <Typography variant="h5" gutterBottom color="primary">
                                9. Titoktartás
                            </Typography>
                            <Typography paragraph>
                                A felek kötelesek a szerződés tartalmát és a tudomásukra jutott üzleti titkokat megőrizni.
                            </Typography>
                        </Box>

                        <Box>
                            <Typography variant="h5" gutterBottom color="primary">
                                10. Záró rendelkezések
                            </Typography>
                            <Typography paragraph>
                                10.1. Az ÁSZF módosításának jogát a vállalkozó fenntartja.
                            </Typography>
                            <Typography paragraph>
                                10.2. A jelen ÁSZF-ben nem szabályozott kérdésekben a Ptk. és a vonatkozó jogszabályok rendelkezései az irányadók.
                            </Typography>
                            <Typography paragraph>
                                10.3. Jogviták esetén a felek törekszenek a békés megegyezésre. Ennek hiányában a [Illetékes bíróság] kizárólagos illetékességét kötik ki.
                            </Typography>
                        </Box>
                    </Paper>
                </motion.div>
            </Container>
        </div>
    );
};

export default Terms; 